// components/ErrorMessage.jsx
import React from 'react';

const ErrorMessage = ({ message }) => {
  if (!message) return null;

  return (
    <div className="xerror-message">
      <p>{message}</p>
    </div>
  );
};

export default ErrorMessage;
